
import Header from "@/components/header/header.vue";
import { reactive, inject, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

export default {
  components: {
    Header,
  },
  setup() {
    const $http: any = inject("$http");
    const route: any = useRoute();
    const router: any = useRouter();
    let list = ref();
    const pickupTruck = async () => {
      let res = await $http.post_stations({ area_id: route.query.row_id });
      if (res.code == 200) {
        list.value = res.data;
      }
    };
    pickupTruck();
    const actv_application_fn = () => {
      window.location.href = "https://m.kilimall.co.ke/application";
    };
    const setUndone = (item: any): void => {
      router.push({
        path: "/address-adds",
        query: {
          row_id: route.query.row_id,
          town_name: route.query.town_name,
          area_name: route.query.area_name,
          area_id: route.query.area_id,
          pickup_id: item.id,
          pickup_name: item.address_name,
          area_door: route.query.area_door,
          pickupout: route.query.pickupout,
        },
      });
    };
    return {
      list,
      actv_application_fn,
      setUndone,
      route,
    };
  },
};
